export default __webpack_public_path__ + "static/media/FundingStage.a717678a.png";